<template>
  <imgBorderContainer title="設計文章" class="company-img-border">
    <div class="company-article">
      <a-row :gutter="[10, 10]">
        <a-col
          :xs="12"
          :sm="12"
          :md="8"
          v-for="(item, index) in list"
          :key="index"
        >
          <card :data="item"></card>
        </a-col>
      </a-row>
    </div>
  </imgBorderContainer>
</template>
<script>
import { primary_site_domain } from "@/config";
import imgBorderContainer from "@/components/imgBorderContainer";
import card from "./card";
export default {
  components: { imgBorderContainer, card },
  data() {
    return {
      domain: primary_site_domain,
      loading: false,
    };
  },
  props: ["list"],
};
</script>
<style lang="less">
.company-img-border {
  .img-border-btn {
    font-size: 24px;
    padding: 20px 100px 30px;
    @media (max-width: 768px) {
      font-size: 18px;
      padding: 10px 60px 20px;
    }
  }
}
.company-article {
  padding: 90px 10px 20px;
  @media (max-width: 768px) {
    padding: 60px 10px 20px;
  }
}
</style>